var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 9.93913 0.421427 8.92172 1.17157 8.17157C1.92172 7.42143 2.93913 7 4 7C5.06087 7 6.07828 7.42143 6.82843 8.17157C7.57857 8.92172 8 9.93913 8 11H7C7 10.2044 6.68393 9.44129 6.12132 8.87868C5.55871 8.31607 4.79565 8 4 8C3.20435 8 2.44129 8.31607 1.87868 8.87868C1.31607 9.44129 1 10.2044 1 11H0ZM4 6.5C2.3425 6.5 1 5.1575 1 3.5C1 1.8425 2.3425 0.5 4 0.5C5.6575 0.5 7 1.8425 7 3.5C7 5.1575 5.6575 6.5 4 6.5ZM4 5.5C5.105 5.5 6 4.605 6 3.5C6 2.395 5.105 1.5 4 1.5C2.895 1.5 2 2.395 2 3.5C2 4.605 2.895 5.5 4 5.5ZM8.142 7.3515C8.84467 7.66796 9.44099 8.18062 9.85929 8.82786C10.2776 9.47509 10.5001 10.2294 10.5 11H9.5C9.50011 10.422 9.33328 9.85625 9.01954 9.37079C8.70581 8.88534 8.25854 8.50083 7.7315 8.2635L8.1415 7.3515H8.142ZM7.798 1.7065C8.30176 1.91415 8.73248 2.26677 9.03551 2.71962C9.33853 3.17246 9.5002 3.70512 9.5 4.25C9.50021 4.93617 9.24385 5.59761 8.78127 6.10441C8.31869 6.61121 7.68333 6.92673 7 6.989V5.9825C7.37047 5.92944 7.71417 5.75901 7.98065 5.49623C8.24713 5.23345 8.42235 4.89216 8.48058 4.52247C8.53881 4.15277 8.47699 3.77415 8.30419 3.44218C8.13139 3.1102 7.85672 2.84237 7.5205 2.678L7.798 1.7065Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipant);
export default __webpack_public_path__ + "static/media/participant.0b277b6c4b9e5c6c20422a9f75a66d1c.svg";
export { ForwardRef as ReactComponent };